import DefaultPaymentCard from './DefaultPaymentCard';

export default DefaultPaymentCard;
